import React__default from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';
import { useEcommFacetContext } from '../context/EcommFacetContext.js';
import { useSunglassesEcommContext } from './context/SunglassesEcommContext.js';
import { WITH_RX } from '../components/RxableSelect/contants.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import { SunglassesTags } from './components/SunglassesTags/SunglassesTags.js';
import { PriceSectionContainer } from '../components/PriceSection/PriceSectionContainer.js';
import { StarRatingReview } from '../../Reviews/StarRatingReview.js';
import { MultiFacetPicker } from '../components/FacetPickerContainers/MultiFacetPicker/MultiFacetPicker.js';
import { SunglassesRxableSelectContainer } from '../components/SunglassesRxableSelect/SunglassesRxableSelectContainer.js';
import ClickAndReserve from '../../ClickAndReserve/components/ClickAndReserveContainer.js';
import { useSunglassesProductData } from '../../../context/product-context-hooks.js';

const SunglassesEcommContent = ({ className , cta , ctaRef  })=>{
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { activeVariant: { displayName , sku: activeSku , isExcludedFromCheckout  } , product ,  } = useSunglassesProductData();
    const { isValid , setNotificationType  } = useEcommFacetContext();
    const { handleConfiguratorClose , isConfiguratorOpen , selectWithRxLens , setSelectWithRxLens  } = useSunglassesEcommContext();
    const { isOfferedWithPrescriptions  } = product;
    var ref;
    const shouldOpenConfigurator = (ref = isOfferedWithPrescriptions && selectWithRxLens === WITH_RX) !== null && ref !== void 0 ? ref : false;
    const { Slots  } = useProductDetailSlots();
    const triggerAlertMessage = React__default.useCallback(()=>{
        setNotificationType('error');
    }, []);
    return /*#__PURE__*/ React__default.createElement("section", {
        "aria-label": displayName,
        className: classnames('sunglasses-ecomm-content', className)
    }, /*#__PURE__*/ React__default.createElement(SunglassesTags, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "sunglasses-ecomm-content__section"
    }, /*#__PURE__*/ React__default.createElement(PriceSectionContainer, null), !isMobile && /*#__PURE__*/ React__default.createElement(StarRatingReview, {
        className: "sunglasses-ecomm-content__star-review"
    })), /*#__PURE__*/ React__default.createElement(MultiFacetPicker, {
        sectionClassName: "sunglasses-ecomm-content__section"
    }, isOfferedWithPrescriptions && /*#__PURE__*/ React__default.createElement(SunglassesRxableSelectContainer, {
        className: "sunglasses-ecomm-content__section"
    })), Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React__default.createElement(Slots.DynamicDeliveryIndicator, {
        isExcludedFromCheckout: isExcludedFromCheckout,
        deliveryItems: [
            {
                sku: activeSku,
                quantity: 1
            }
        ],
        withRxLens: shouldOpenConfigurator
    }) : null, /*#__PURE__*/ React__default.createElement("div", {
        ref: ctaRef
    }, cta), /*#__PURE__*/ React__default.createElement(ClickAndReserve, {
        sku: activeSku,
        onInvalidClick: !isValid ? triggerAlertMessage : undefined
    }), Slots.AfterCTA ? /*#__PURE__*/ React__default.createElement(Slots.AfterCTA, null) : null, Slots.Configurator && /*#__PURE__*/ React__default.createElement(Slots.Configurator, {
        id: "rxSun",
        onModalClose: handleConfiguratorClose,
        isOpen: isConfiguratorOpen
    }));
};

export { SunglassesEcommContent };
//# sourceMappingURL=SunglassesEcommContent.js.map
